import localization from "~/src/static/localization/landing/introduction"

export const selectQuoteTypeLocalization = (quote,language) => {
    localization.setLanguage(language)
    if (quote.quote_type == "call_me_back") return localization.call_me_back
    return localization.reserve
}